export const COPAY_COMPLETED_CLAIMS_TABLE = [ 
  {
    value: 'case_id',
    label: 'Case ID',
  },
  {
    value: 'patient_name',
    label: 'Patient',
  },
  {
    value:'',
    label:'Product'
  },
  {
    value:'submitting_practice',
    label:'Submitting Practice'
  },
  {
    value:'claim_status',
    label:'Claim Status'
  },
  {
    value:'paid_claim_amount',
    label:'Paid Claim Amount'
  },
  {
    value:'paid_claim_date',
    label:'Paid Claim Date'
  },
  {
    value:'remaining_copay_available',
    label:'Remaining Co-Pay Benefit Available'
  }
];
